export default {
  rations: null
}
